export default __webpack_public_path__ + "static/media/room-9.18aabe9f.jpg";